﻿module.exports = BrowserSession;

var currentDate = new Date();
var instances;

function BrowserSession() {



    var ifSessionActive = false;
    var currentSessionData;
    var currentSession = localStorage['activeSession'];


    if (currentSession !== undefined && currentSession !== null) {

        currentSessionData = JSON.parse(currentSession);
        var lastDate = new Date(currentSessionData.lastTimeLogoDisplay);
        instances = Number(currentSessionData.instances) + 1;
        if (!currentSessionData.active) {
            activateSession();
        }
        else if (currentDate - lastDate > 3600000) {
            activateSession();
        }
        else {
            ifSessionActive = true;
        }
    }
    else {
        instances = 1;
        activateSession();
    }
    return ifSessionActive;
}

var activateSession = function () {
    var activeSession = {
        active: true,
        lastTimeLogoDisplay: currentDate,
        instances: instances
    };
    localStorage['activeSession'] = JSON.stringify(activeSession);
};
